/* eslint-disable */
import axiosIns, {axiosDefault} from '@/libs/axios'
import { requestApi } from '@/libs/secret'

export default {
  namespaced: true,
  state: {
    dataClient: {
      page: 1,
      fields: [
        { key: 'company_name', label: 'Company', sortable: true },
        { key: 'country_name', label: 'Country', sortable: true },
        { key: 'province_name', label: 'Province', sortable: true },
        { key: 'city_name', label: 'City', sortable: true },
        { key: 'company_type_name', label: 'Type', sortable: true },
        { key: 'status', label: 'Status' },
        { key: 'actions', label: 'Action' },
      ],
      items: {
        total: 6,
        per_page: 6,
        current_page: 1,
        from: 1,
        to: 6,
        data: [],
      },
      status: [
        {
          1: 'Waiting Approval', 2: 'Approved', 3: 'Rejected',
        },
        {
          1: 'light-warning', 2: 'light-success', 3: 'light-danger',
        },
      ],
      sortBy:'',
      sortDesc: false,
      search: '',
    },
    accessManagement: [],
    companyDetail: {},
    clientId: null,
    telcoClientId: '',
    telcoClientSecret: '',
    statusApprove: 1,
    reason: ['ok'],
    listReason: [],
  },
  getters: {
    getClientPage: state => state.dataClient.page,
    getClientItem: state => state.dataClient.items,
    getClientField: state => state.dataClient.fields,
    getClientStatus: state => state.dataClient.status,
    getCompanyDetail: state => state.companyDetail,
    getClientId: state => state.clientId,
    getTelcoClientId: state => state.telcoClientId,
    getTelcoClientSecret: state => state.telcoClientSecret,
    getStatusApprove: state => state.statusApprove,
    getReason: state => state.reason,
    getListReason: state => state.listReason,
    getCurrentPage: state => state.dataClient.items.current_page,
    getSortBy: state => state.dataClient.sortBy,
    getSortDesc: state => state.dataClient.sortDesc,
    getSearch: state => state.dataClient.search,
  },
  mutations: {
    SET_DATA_CLIENT_ITEM: (state, value) => (value ? (state.dataClient.items = value) : (state.dataClient.items = [])),
    SET_COMPANY_DETAIL: (state, value) => (value ? (state.companyDetail = value) : (state.companyDetail = {})),
    SET_CLIENT_ID: (state, value) => (value ? (state.clientId = value) : (state.clientId = null)),
    SET_TELCO_CLIENT_ID: (state, value) => (value ? (state.telcoClientId = value) : (state.telcoClientId = '')),
    SET_TELCO_CLIENT_SECRET: (state, value) => (value ? (state.telcoClientSecret = value) : (state.telcoClientSecret = '')),
    SET_STATUS_APPROVE: (state, value) => (value ? (state.statusApprove = value) : (state.statusApprove = 1)),
    SET_REASON: (state, value) => (value ? (state.reason = value) : (state.reason = [])),
    SET_LIST_REASON: (state, value) => (value ? (state.listReason = value) : (state.listReason = [])),
    SET_ITEM_DATA: (state, value) => (value ? (state.dataClient.items.data = value) : (state.dataClient.items.data = [])),
    SET_LIST_CURRENT_PAGE: (state, value) => (value ? (state.dataClient.items.current_page = value) : (state.dataClient.items.current_page = 1)),
    SET_LIST_SORT_BY: (state, value) => (value ? (state.dataClient.sortBy = value) : (state.dataClient.sortBy = '')),
    SET_LIST_SORT_DESC: (state, value) => (value ? (state.dataClient.sortDesc = value) : (state.dataClient.sortDesc = false)),
    SET_LIST_SEARCH: (state, value) => (value ? (state.dataClient.search = value) : (state.dataClient.search = '')),
  },
  actions: {
    clearTable({commit}) {
      commit('SET_LIST_CURRENT_PAGE')
      commit('SET_LIST_SORT_BY')
      commit('SET_LIST_SORT_DESC')
      commit('SET_LIST_SEARCH')
    },
    getDataList({ commit, getters, rootState }) {
      const desc = (getters.getSortDesc) ? 'desc' : 'asc'
      const headers = { Authorization: `Bearer ${rootState.auth.userData.data.accessToken}` }
      commit('SET_ITEM_DATA')
      return new Promise((resolve, reject) => {
        const queryParam = requestApi(`page=${getters.getCurrentPage}&filter=${getters.getSearch}&sortby=${getters.getSortBy}&sortdir=${desc}&status=${getters.getStatusApprove}`)
        axiosIns.get(`/account?req=${queryParam.req}`, { headers })
          .then(response => {
            const newData = response.data
            commit('SET_DATA_CLIENT_ITEM', newData)
            resolve(response.data)
          }).catch(error => {
            reject(error)
          })
      })
    },
    setTelcoCredential({getters, rootState}) {
      const headers = { Authorization: `Bearer ${rootState.auth.userData.data.accessToken}` }
      const sendData = {
        client_id: getters.getClientId,
        telco_client_id: getters.getTelcoClientId,
        telco_client_secret: getters.getTelcoClientSecret,
      }
      console.log(sendData);
      return new Promise((resolve, reject) => {
        axiosIns.post('/account/settelcocredential', sendData, { headers })
          .then(response => {
            resolve(response)
          }).catch(error => {
            reject(error)
          })
      })
    },
    approveClient({ commit, getters, rootState }) {
      const headers = { Authorization: `Bearer ${rootState.auth.userData.data.accessToken}` }
      const sendData = {
        client_id: getters.getClientId,
        reason: getters.getReason,
        status: getters.getStatusApprove,
      }
      return new Promise((resolve, reject) => {
        axiosIns.post('/account/approval', sendData, { headers })
          .then(response => {
            commit('SET_CLIENT_ID', getters.getClientId)
            resolve(response.data)
          }).catch(error => {
            reject(error)
          })
      })
    },
    listReason({ commit, rootState }) {
      const headers = { Authorization: `Bearer ${rootState.auth.userData.data.accessToken}` }
      return new Promise((resolve, reject) => {
        axiosIns.get('/reason/type/1', { headers })
          .then(response => {
            commit('SET_LIST_REASON', response.data.data)
            resolve(response.data.data)
          }).catch(error => {
            reject(error)
          })
      })
    },
    downloadTable({ getters, rootState }, payload) {
      const desc = (getters.getManageSortDesc) ? 'desc' : 'asc'
      // const user = rootState.auth.userData.data.id
      const headers = { Authorization: `Bearer ${rootState.auth.userData.data.accessToken}` }
      return new Promise((resolve, reject) => {
        const queryParam = requestApi(`filter=${getters.getSearch}&sortby=${getters.getSortBy}&sortdir=${desc}&status=${getters.getStatusApprove}&type=${payload}`)
        axiosDefault.get(`/account/download?req=${queryParam.req}`, { headers, responseType: 'blob' })
          .then(response => {
            // const newData = response.data
            // let blob = new Blob([response.data], { type: 'application/pdf' }),
            // url = window.URL.createObjectURL(blob)
            // window.open(url)
            resolve(response.data)
          }).catch(error => {
            reject(error)
          })
      })
    },
    resetCredential({commit}){
      commit('SET_TELCO_CLIENT_ID')
      commit('SET_TELCO_CLIENT_SECRET')
    },
  },
}
